import React from 'react';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { SidePanel } from 'polotno/side-panel';
import { Workspace } from 'polotno/canvas/workspace';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';

import { Topbar } from './topbar';

import { SizeSection } from './side-panels/size-section';
import { TemplatesSection } from './side-panels/templates-section';
import { TextSection } from './side-panels/text-section';

import { ProjectsSection } from './side-panels/projects-section';
import { MaterialsSection } from './side-panels/materials-section';
import { SystemsSection } from './side-panels/systems-section';
import { InspirationSection } from './side-panels/inspiration-section';
import { ImagesSection } from './side-panels/images-section';
import { MyArtboardsSection } from './side-panels/my-artboards-section';

import { PageControls } from './page-controls';

import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/popover2/lib/css/blueprint-popover2.css';
import './index.css';

const sections = [
  MyArtboardsSection,
  SizeSection,
  TemplatesSection,
  TextSection,
  ImagesSection,
  ProjectsSection,
  MaterialsSection,
  SystemsSection,
  InspirationSection,
];

const App = ({ store }) => {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
      className="carvart-editor"
    >
      <Topbar store={store} />
      <div style={{ height: 'calc(100% - 50px)' }}>
        <PolotnoContainer className="polotno-app-container">
          <SidePanelWrap>
            <SidePanel
              store={store}
              sections={sections}
              defaultSection="size"
            />
          </SidePanelWrap>
          <WorkspaceWrap>
            <Toolbar
              store={store}
              hideOpacity
              hideImageFlip
              hideSvgEffects
              hideImageEffects
              hideTextFontFamily
              hideTextEffects
              hideTextSpacing
            />
            <Workspace store={store} components={{ PageControls }} />
            <ZoomButtons store={store} />
          </WorkspaceWrap>
        </PolotnoContainer>
      </div>
    </div>
  );
};

export default App;
